//#region src/polyfills/index.ts
Promise.withResolvers === void 0 && (Promise.withResolvers = () => {
	let e, t, n = new Promise((n, r) => {
		e = n, t = r;
	});
	return {
		resolve: e,
		reject: t,
		promise: n
	};
});
//#endregion
//#region src/browser/index.ts
function e(e) {
	let t = document.cookie.match(`\\b${e}=([^;]*)\\b`);
	return t ? t[1] : void 0;
}
function t() {
	let e = "testData";
	try {
		let { localStorage: t } = window;
		t.setItem(e, e), t.getItem(e), t.removeItem(e);
	} catch {
		return !1;
	}
	return !0;
}
function n() {
	if (typeof globalThis.crypto.randomUUID == "function") return globalThis.crypto.randomUUID();
	let e = globalThis.crypto.getRandomValues(/* @__PURE__ */ new Uint8Array(16));
	e[6] = e[6] & 15 | 64, e[8] = e[8] & 63 | 128;
	let t = Array.from(e, (e) => e.toString(16).padStart(2, "0")).join("");
	return [
		t.slice(0, 8),
		t.slice(8, 12),
		t.slice(12, 16),
		t.slice(16, 20),
		t.slice(20)
	].join("-");
}
var r = [
	{
		name: "Edge",
		pattern: /(?:EdgA|EdgiOS|Edg)\/([\d.]+)/i
	},
	{
		name: "Opera",
		pattern: /(?:OPR|Opera)\/([\d.]+)/i
	},
	{
		name: "Samsung Internet",
		pattern: /SamsungBrowser\/([\d.]+)/i
	},
	{
		name: "UCBrowser",
		pattern: /(?:UCBrowser|UC Browser)\/([\d.]+)/i
	},
	{
		name: "QQBrowser",
		pattern: /MQQBrowser\/([\d.]+)/i
	},
	{
		name: "Maxthon",
		pattern: /Maxthon\/([\d.]+)/i
	},
	{
		name: "IE",
		pattern: /MSIE\s([\d.]+)/i
	},
	{
		name: "IE",
		pattern: /Trident\/.*?rv:([\d.]+)/i
	},
	{
		name: "Chrome",
		pattern: /(?:CriOS|Chrome)\/([\d.]+)/i
	},
	{
		name: "Firefox",
		pattern: /(?:FxiOS|Firefox)\/([\d.]+)/i
	}
], i = [
	{
		os: "iOS",
		pattern: /(?:iPhone|iPad|iPod)/i
	},
	{
		os: "Windows Phone",
		pattern: /Windows Phone/i
	},
	{
		os: "Windows",
		pattern: /Windows/i
	},
	{
		os: "Android",
		pattern: /Android/i
	},
	{
		os: "Chromium OS",
		pattern: /CrOS/i
	},
	{
		os: "Mac OS",
		pattern: /(?:Macintosh|Mac OS X)/i
	},
	{
		os: "Ubuntu",
		pattern: /Ubuntu/i
	},
	{
		os: "Linux",
		pattern: /Linux/i
	}
], a, o;
function s(e) {
	if (a === e && o !== void 0) return o;
	let t, n;
	for (let { name: i, pattern: a } of r) {
		let r = a.exec(e);
		if (r?.[1]) {
			t = i, n = r[1];
			break;
		}
	}
	if (!t && /Safari\//i.test(e)) {
		let r = /Version\/([\d.]+)/i.exec(e)?.[1];
		r && (t = /(?:iPhone|iPad|iPod)/i.test(e) ? "Mobile Safari" : "Safari", n = r);
	}
	let s;
	/(?:SMART-TV|SmartTV|Tizen|Web0S|webOS)/i.test(e) ? s = "smarttv" : /(?:watchOS|Watch OS|Wear OS|Galaxy Watch)/i.test(e) ? s = "wearable" : /(?:Xbox|PlayStation|Nintendo)/i.test(e) ? s = "console" : /(?:CrKey|Chromecast)/i.test(e) ? s = "embedded" : /(?:iPad|Tablet|PlayBook|Silk\/)/i.test(e) || /Android/i.test(e) && !/Mobile/i.test(e) ? s = "tablet" : /(?:Mobi|iPhone|iPod|Windows Phone|IEMobile|Opera Mini)/i.test(e) && (s = "mobile");
	let c = i.find(({ pattern: t }) => t.test(e))?.os, l = {
		browserName: t,
		browserVersion: n,
		deviceType: s,
		os: c
	};
	return a = e, o = l, l;
}
//#endregion
//#region src/config/index.ts
function c(e) {
	return Array.isArray(e) && e.length > 0 && e.every((e) => typeof e == "string" && e.trim().length > 0);
}
function l(e) {
	return typeof structuredClone == "function" ? structuredClone(e) : JSON.parse(JSON.stringify(e));
}
function u(e) {
	return Object.freeze(e), Array.isArray(e) ? e.forEach((e) => {
		typeof e == "object" && e && !Object.isFrozen(e) && u(e);
	}) : Object.values(e).forEach((e) => {
		typeof e == "object" && e && !Object.isFrozen(e) && u(e);
	}), e;
}
var d = (() => {
	let e = window.__streamlit;
	if (e) return u(l(e));
})();
function f() {
	return d;
}
var p = {
	get BACKEND_BASE_URL() {
		return d?.BACKEND_BASE_URL;
	},
	get HOST_CONFIG_BASE_URL() {
		return d?.HOST_CONFIG_BASE_URL;
	},
	get DOWNLOAD_ASSETS_BASE_URL() {
		return d?.DOWNLOAD_ASSETS_BASE_URL;
	},
	get MAIN_PAGE_BASE_URL() {
		return d?.MAIN_PAGE_BASE_URL;
	},
	get CUSTOM_COMPONENT_CLIENT_ID() {
		return d?.CUSTOM_COMPONENT_CLIENT_ID;
	},
	get LIGHT_THEME() {
		return d?.LIGHT_THEME;
	},
	get DARK_THEME() {
		return d?.DARK_THEME;
	},
	get ENABLE_RELOAD_BASED_ON_HARDCODED_STREAMLIT_VERSION() {
		return d?.ENABLE_RELOAD_BASED_ON_HARDCODED_STREAMLIT_VERSION;
	},
	get HOST_CONFIG() {
		return d?.HOST_CONFIG;
	}
};
//#endregion
//#region src/types/index.ts
function m(e) {
	return e != null;
}
function h(e) {
	return e == null;
}
//#endregion
//#region src/uri/index.ts
var g = /\/+$/, _ = /^\/+/;
function v({ hostname: e, port: t, pathname: n, protocol: r }, i) {
	let a = y(n, i);
	return `${r}//${e}${t ? `:${t}` : ""}/${a}`;
}
function y(e, t) {
	return e = e.replace(g, "").replace(_, ""), t = t.replace(g, "").replace(_, ""), e.length === 0 ? t : `${e}/${t}`;
}
var b = () => window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
//#endregion
export { p as StreamlitConfig, v as buildHttpUri, n as generateUuid, e as getCookie, f as getStreamlitConfig, b as isLocalhost, h as isNullOrUndefined, c as isValidAllowedOrigins, t as localStorageAvailable, y as makePath, m as notNullOrUndefined, s as parseUserAgent };
